import { useEffect, useState } from 'react';

/**
 * Hook для автоматического масштабирования приложения под разные экраны.
 * Базовое разрешение: 2560px (масштаб 100%, font-size: 16px).
 * 
 * Устанавливает font-size на <html> пропорционально ширине окна,
 * и возвращает текущий scale множитель для масштабирования Canvas.
 */
export const useResponsiveZoom = () => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      const width = window.innerWidth;
      const BASE_WIDTH = 2560;
      const BASE_FONT_SIZE = 16;

      // Вычисляем пропорциональный font-size
      let fontSize = (width / BASE_WIDTH) * BASE_FONT_SIZE;
      
      // Ограничиваем: минимум 8px, максимум 16px
      fontSize = Math.max(8, Math.min(fontSize, BASE_FONT_SIZE));

      // Применяем font-size к <html>
      document.documentElement.style.fontSize = fontSize + 'px';

      // Вычисляем scale
      const currentScale = fontSize / BASE_FONT_SIZE;
      setScale(currentScale);
    };

    updateScale();
    window.addEventListener('resize', updateScale);

    return () => {
      window.removeEventListener('resize', updateScale);
    };
  }, []);

  return scale;
};
